/** @jsxImportSource @emotion/react */
import logo from '../../images/logo.svg';
import { colors, Container, Divider, Link, Stripes, Text, TextSmall } from '../../ui';

const Footer = ({ openPdfModal }) => (
  <footer
    css={{
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    <Divider />
    <Container>
      <div css={{ position: 'relative', flexDirection: 'column' }}>
        <div css={{ alignItems: 'center', justifyContent: 'space-between', padding: '33px 0' }}>
          <img src={logo} css={{ marginRight: 50 }} />

          <div css={{ flexWrap: 'wrap', textAlign: 'center', justifyContent: 'center' }}>
            <Link onClick={() => openPdfModal('privacyPolicy')}>Политика конфиденциальности</Link>
            <Text css={{ marginLeft: 20, marginRight: 20 }}>|</Text>
            <Link onClick={() => openPdfModal('offer')}>Оферта</Link>
            <Text css={{ marginLeft: 20, marginRight: 20 }}>|</Text>
            <Link href="https://vk.com/vsemsmm1">Техническая поддержка</Link>
          </div>
        </div>
      </div>
    </Container>
    <div
      css={{
        justifyContent: 'center',
        paddingTop: 15,
        paddingBottom: 15,
        width: '100%',
        background: colors.black,
      }}
    >
      <TextSmall css={{ color: '#fff !important' }}>
        Copyright © “Super-smm” 2021, All rights reserved.
      </TextSmall>
    </div>
  </footer>
);

export default Footer;
